<template>
    <v-container v-if="!!courierinfo && !!courierinfo.user" fluid>
        <v-row justify="center">
            <v-col md="6">
                <courierinfo-edit-form
                    v-bind:title="`Editing courier`"
                    v-bind:courierinfo="courierinfo"
                    v-on:submit="submit"
                    v-on:cancel="$router.go(-1)"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import courierApi from '@/api/courierApi';
import snackbar from '@/utils/snackbar';

export default {
    components: {
        'courierinfo-edit-form': () => import('@/views/op/CourierEditForm.vue')
    },
    data() {
        return {
            courierinfo: null
        };
    },
    methods: {
        async submit() {
            const response = await courierApi.updateCourier(
                this.courierinfo.id,
                this.courierinfo
            );
            this.$router.push({
                name: 'op-courierinfo-show',
                params: { courierinfo_id: response.data.courierinfo.id }
            });
            snackbar.show('Courier updated', 'success');
        }
    },
    async beforeRouteEnter(to, from, next) {
        const courierinfoId = to.params.courierinfo_id;
        const response = await courierApi.getCourier(courierinfoId);
        next(vm => (vm.courierinfo = response.data.courierinfo));
    }
};
</script>
